import React, { useEffect, useState } from "react";
import { Avatar, Button, Input, Pagination, Table, Toggle } from "rsuite";
import { EmployeeDataVM } from "../../Models/ViewModels";
import * as EmployeeData from "../../Services/EmployeeDB";
import { GetUserLoginID, SetIDRole } from "../../Services/UserSessionManager";
import { PageHeader } from "../../SharedComponents/PageHeader";
import { EmployeeTeamDetailCard } from "./EmployeeTeamDetailCard";
import { EmployeeInformation } from "../EmployeeInformation/EmployeeInfo";
import "./EmployeeTeamsList.css";
import { EmployeeInfoModal } from "./EmployeeInfomodal";
import { handleDownloadAsExcel } from "../../Helpers/Utils";

import {
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";

const { Column, HeaderCell, Cell } = Table;

export const EmployeeDataList = () => {
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [isLoading, setLoading] = useState(true);

  const [limit, setLimit] = React.useState(15);
  const [page, setPage] = React.useState(1);
  const [tableInfo, setTableInfo] = useState(new Array<EmployeeDataVM>());
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<EmployeeDataVM>()
  );
  const [toggled, setToggled] = useState(false);
  const [popup, setpopUp] = useState(false);
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [searching, setSearching] = useState(false);
  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");
  const handleClose = () => setpopUp(false);
  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });
  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  useEffect(() => {
    EmployeeData.GetEmployeeDataStats(loginid).then((resp) => {
      setTableInfo(resp.data);
      setFilteredEmployeesList(resp.data);
      setLoading(false);
    });
  }, []);

  const filterData = () => {
    setPage(1);
    let search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;
    let search2value = (document.getElementById("Search2") as HTMLInputElement)
      .value;

    setFilteredEmployeesList(
      tableInfo.filter(
        (e) =>
          includesSearchValue(e, searchby, search1value) &&
          includesSearchValue(e, searchby2, search2value)
      )
    );
  };

  const includesSearchValue = (
    e: EmployeeDataVM,
    searchBy: string,
    searchText: string
  ) => {
    switch (searchBy) {
      case "ID":
        return e.EmployeeID.toLowerCase().includes(searchText.toLowerCase());

      case "Name":
        return e.EmployeeName.toLowerCase().includes(searchText.toLowerCase());

      case "Reporting PM 1":
        return e.ReportingOfficerID1.toLowerCase().includes(
          searchText.toLowerCase()
        );
      case "Reporting PM 2":
        return e.ReportingOfficerID2.toLowerCase().includes(
          searchText.toLowerCase()
        );

      case "Branch":
        return e.Branch.toLowerCase().includes(searchText.toLowerCase());

      case "Designation":
        return e.Designation.toLowerCase().includes(searchText.toLowerCase());

      case "Department":
        return e.Department.toLowerCase().includes(searchText.toLowerCase());

      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };

  const fetchTeam = (val: []) => {
    return (
      <div className="d-flex flex-column gap-1">
        {" "}
        {val.map((lookupName) => {
          return (
            <>
              <div>{lookupName}</div>
            </>
          );
        })}
      </div>
    );
  };

  const fetchAllocationBuffer = (allocation: number, buffer: number) => {
    return (
      <div>
        {allocation}% / {buffer}%
      </div>
    );
  };

  const handelDetailsPopUp = (rowdata: any) => {
    setId(rowdata.EmployeeID);
    setTitle(rowdata.EmployeeName);
    setpopUp(true);
  };

  const SearchBy = (value: any) => {
    setSearchBy(value);
  };

  const SearchBy2 = (value: any) => {
    setSearchBy2(value);
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-5">
          <PageHeader title="Employees List" backPage="">
            <></>
          </PageHeader>
        </div>

        {!toggled ? (
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6">
                <InputGroup className="mb-3">
                  <DropdownButton
                    variant="outline-secondary"
                    title={searchby}
                    id="input-group-dropdown-1"
                  >
                    <Dropdown.Item href="#" onClick={() => SearchBy("ID")}>
                      ID
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy("Name")}>
                      Name
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy("Branch")}>
                      Branch
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Designation")}
                    >
                      Designation
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Reporting PM 1")}
                    >
                      Reporting PM 1
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Reporting PM 2")}
                    >
                      Reporting PM 2
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy("Dropdown")}
                    >
                      Default
                    </Dropdown.Item>
                  </DropdownButton>
                  <Form.Control
                    aria-label="Text input with dropdown button"
                    id="Search1"
                    onChange={(event) => filterData()}
                    placeholder="Search..."
                  />
                </InputGroup>
              </div>
              <div className="col-md-6">
                <InputGroup className="mb-3">
                  <DropdownButton
                    variant="outline-secondary"
                    title={searchby2}
                    id="input-group-dropdown-1"
                  >
                    <Dropdown.Item href="#" onClick={() => SearchBy2("ID")}>
                      ID
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy2("Name")}>
                      Name
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={() => SearchBy2("Branch")}>
                      Branch
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Designation")}
                    >
                      Designation
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Department")}
                    >
                      Department
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Reporting PM 1")}
                    >
                      Reporting PM 1
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Reporting PM 2")}
                    >
                      Reporting PM 2
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={() => SearchBy2("Dropdown")}
                    >
                      Default
                    </Dropdown.Item>
                  </DropdownButton>
                  <Form.Control
                    aria-label="Text input with dropdown button"
                    id="Search2"
                    onChange={(event) => filterData()}
                    placeholder="Search..."
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-3 "></div>
        )}

        <div className="col-md-1">
          <Toggle
            size="lg"
            checkedChildren="Table"
            unCheckedChildren="Cards"
            onChange={(toggled: boolean, event) => setToggled(toggled)}
          />
        </div>

        <hr />
      </div>
      {!toggled ? (
        <div>
          <Modal show={popup} fullscreen={true} onHide={handleClose}>
            <EmployeeInfoModal id={id} title={title} />
          </Modal>

          <Table
            id="table"
            data={tableDataFeed}
            loading={isLoading}
            autoHeight={true}
            headerHeight={30}
            rowHeight={(rowValue: any) => {
              if (
                rowValue &&
                rowValue.LookUpName &&
                rowValue.LookUpName.length > 1
              )
                return 23 * rowValue.LookUpName.length;
              return 28;
            }}
            bordered={true}
            cellBordered={true}
            className="border border-dark mt-2"
            onRowClick={(rowData: object) => {
              handelDetailsPopUp(rowData);
            }}
          >
            <Column flexGrow={40} align="center" fixed>
              <CustomTableHeaderCell placement={"Id"}>Id</CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: any) => {
                  return <a href="#">{rowData.EmployeeID}</a>;
                }}
              </CustomTableCell>
            </Column>
            <Column width={180} fixed>
              <CustomTableHeaderCell placement={"Name"}>
                Name
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="EmployeeName" />
            </Column>
            <Column resizable width={220}>
              <CustomTableHeaderCell
                placement={" Team-SubTeam-Process-All%-Buff%"}
              >
                Team-SubTeam-Process-All%-Buff%
              </CustomTableHeaderCell>
              <CustomTableCell height={500}>
                {(rowData: any) => {
                  return fetchTeam(rowData.LookUpName);
                }}
              </CustomTableCell>
            </Column>
            <Column width={120} resizable>
              <CustomTableHeaderCell placement={"Allocation% / Buffer%"}>
                Allocation% / Buffer%
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: any) => {
                  return fetchAllocationBuffer(
                    rowData.AllocationPercent,
                    rowData.BufferPercent
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column width={130} resizable>
              <CustomTableHeaderCell placement={"Branch"}>
                Branch
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Branch" />
            </Column>
            <Column width={200}>
              <CustomTableHeaderCell placement={"Designation"}>
                Designation
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Designation" />
            </Column>
            <Column width={140}>
              <CustomTableHeaderCell placement={"Department"}>
                Department
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Department" />
            </Column>
            <Column width={150}>
              <CustomTableHeaderCell placement={"Shift"}>
                Shift
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="ShiftTiming" />
            </Column>
            <Column width={250}>
              <CustomTableHeaderCell placement={"Reporting PM1"}>
                Reporting PM1
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="ReportingOfficerID1" />
            </Column>
            <Column width={200}>
              <CustomTableHeaderCell placement={"Reporting PM2"}>
                Reporting PM2
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="ReportingOfficerID2" />
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredEmployeesList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      ) : (
        <EmployeeTeamDetailCard />
      )}
      <div className="row">
        <div className="col-md-10"></div>
      </div>
    </div>
  );
};
